import { render, staticRenderFns } from "./goods-specs-modal1.vue?vue&type=template&id=d2a7c404&scoped=true&"
import script from "./goods-specs-modal1.vue?vue&type=script&lang=js&"
export * from "./goods-specs-modal1.vue?vue&type=script&lang=js&"
import style0 from "./goods-specs-modal1.vue?vue&type=style&index=0&id=d2a7c404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a7c404",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2a7c404')) {
      api.createRecord('d2a7c404', component.options)
    } else {
      api.reload('d2a7c404', component.options)
    }
    module.hot.accept("./goods-specs-modal1.vue?vue&type=template&id=d2a7c404&scoped=true&", function () {
      api.rerender('d2a7c404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/goods-specs-modal1.vue"
export default component.exports